import { cloneElement } from 'react';
import { Box, Button, Typography, useTheme } from '@mui/material';

interface IEmptyStateProps {
  icon: React.ReactElement;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

// Ícone + título + descrição + ação opcional de retry (guia seção 48).
export const EmptyState: React.FC<IEmptyStateProps> = ({ icon, title, description, actionLabel, onAction }) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5, py: 6 }}>
      {cloneElement(icon, { sx: { fontSize: 52, color: theme.torq.text.muted, ...(icon.props?.sx || {}) } })}
      <Typography variant="h6" sx={{ color: theme.torq.text.primary, fontSize: '1rem', fontWeight: 600 }}>
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" sx={{ color: theme.torq.text.secondary, textAlign: 'center', maxWidth: 380 }}>
          {description}
        </Typography>
      )}
      {actionLabel && onAction && (
        <Button variant="outlined" size="small" onClick={onAction} sx={{ mt: 1 }}>
          {actionLabel}
        </Button>
      )}
    </Box>
  );
};
